//** List Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getCampaignType = createAsyncThunk('campaignTypeSlice/getCampaignType', async () => {
    try {
        let response = await axios.get('/campaign-type', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCampaignTypeOption = createAsyncThunk('campaignTypeSlice/getCampaignTypeOption', async () => {
    try {
        let response = await axios.get('/campaign-type/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createCampaignType = createAsyncThunk('campaignTypeSlice/createCampaignType', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/campaign-type', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Campaign Type added successfully.');
        dispatch(getCampaignType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCampaignType = createAsyncThunk('campaignTypeSlice/updateCampaignType', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/campaign-type/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Campaign Type updated successfully.');
        await dispatch(getCampaignType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCampaignTypeStatus = createAsyncThunk('campaignTypeSlice/updateCampaignTypeStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/campaign-type/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Campaign Type Status updated successfully !');
        dispatch(getCampaignType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteCampaignType = createAsyncThunk('campaignTypeSlice/deleteCampaignType', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/campaign-type/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Campaign Type deleted successfully.');
        await dispatch(getCampaignType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const campaignTypeSlice = createSlice({
    name: 'campaignTypeSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCampaignType.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getCampaignTypeOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default campaignTypeSlice.reducer;
